import { render, staticRenderFns } from "./Sale-form.vue?vue&type=template&id=6a8e218c&scoped=true"
import script from "./Sale-form.vue?vue&type=script&lang=js"
export * from "./Sale-form.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Sale-form.vue?vue&type=style&index=1&id=6a8e218c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e218c",
  null
  
)

export default component.exports